function InfoIcon({ color }) {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill={color}>
            <path d="M13 2.16667C7.02002 2.16667 2.16669 7.02 2.16669 13C2.16669 18.98 7.02002 23.8333 13 23.8333C18.98 23.8333 23.8334 18.98 23.8334 13C23.8334 7.02 18.98 2.16667 13 2.16667ZM13 18.4167C12.4042 18.4167 11.9167 17.9292 11.9167 17.3333V13C11.9167 12.4042 12.4042 11.9167 13 11.9167C13.5959 11.9167 14.0834 12.4042 14.0834 13V17.3333C14.0834 17.9292 13.5959 18.4167 13 18.4167ZM14.0834 9.75H11.9167V7.58333H14.0834V9.75Z" />
        </svg>
    );
}

export default InfoIcon;
